enum StrategyType {
  TEXT_BOOK = 1,
  TALENTED = 2,
  EXAMS = 3,
  NATIONAL_EXAM = 4,
  ENTRANCE_EXAM = 5,
}

export default StrategyType;
